<template>
  <!--<div id="app" :style="`background-image: url('/static/img/bg/bg_0${bgImgIndex}.jpg')`">-->
  <div id="app">
    <!--<img src="./img/img/a20_bg.png" class="qf-bg-color-img" alt="">-->
    <router-view></router-view>
    <alanModal></alanModal>
    <!-- <chatMessage v-if="isLogin"></chatMessage>
    <chatRoom v-if="isLogin"></chatRoom> -->
    <div id="loadingBoxs_only" class="loadingBoxs" v-show="isLoading">
      <img src="/static/img/loading.gif" alt="">
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {mapMutations, mapState} from 'vuex'
  import alanModal from "./components/lotteryRefactoring/alanModal.vue";
	import chatMessage from "./components/chatMessage/chatMessage.vue";
	import chatRoom from './components/chatRoom_pc.vue'; // 引入消息推送文件

  export default {
  data() {
    return {
      isLogin: this.$store.state.isLogin === 'true' ? true : false,
    };
  },
    methods: {
      ...mapMutations(['setData']),
      getBgIndex() { // 设置默认背景图片
        let bgIndex = sessionStorage.getItem('bgImgIndex');
        if (bgIndex === null) {
          sessionStorage.setItem('bgImgIndex', 0);
          this.setData({
            key: 'bgImgIndex',
            value: 1
          })
        } else {
          this.setData({
            key: 'bgImgIndex',
            value: bgIndex
          })
        }
      },
      goToMobile() {
        let href = window.location.href
        /*if (href.indexOf('/register') === -1 && href.indexOf('/noLoginActivity') === -1) {
                                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                                        location.href = '/login.html';
                                }
                                if (/(Android)/i.test(navigator.userAgent)) {
                                        location.href = '/login.html';
                                }
                        }*/
        // 改变title
        if (href.indexOf('/lottery#') === -1 && href.indexOf('/pankou#') === -1) {
          // document.title = appConfig.title
//        	localStorage.setItem('_showFooter',true)
        } else {
//      	localStorage.setItem('_showFooter',false)
        }
      },
    },
    computed: {
      ...mapState(['bgImgIndex','isLoading'])
    },
    components: {alanModal,chatMessage,chatRoom},
    created() {
      // App.alert('warning', '提示消息','9999999', 400000);
      // App.confirm('question', '确认消息', '确定要撤销该订单？', 0, '确定', '取消', function () {
      //     that.ok_WithdrawalOrder(that.modal_data)
      // });
      this.goToMobile();
      this.$store.dispatch('getAppconfig');
      this.getBgIndex();
      // this.$http.get('/upload/json/kefu.json', {}).then(res => {
      //   // console.log(res,'----------')
      //   // this.$store.commit('setData', {key: 'kefuData', value: });
      //   res && this.setData({
      //     key: 'kefuData',
      //     value: res.bodyText.split('@')[1]
      //   })
      //   // document.body.getElementsByTagName('title')[0].innerHTML = res.body.name
      // })
    },
    watch: {
      '$route'(to) {
        this.goToMobile()
      }
    }
  }
</script>

<style lang="less">
  @import "./css/commit/base.less";
  @import './css/commit/jbox.css';
  .loadingBoxs{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    text-align: center;
    line-height: 100vh;
    z-index: 100000;
    img{
      width: 70px;
    }
  }
  .process .noUi-base .noUi-origin{
    background-color: #c5b7a4 !important;
  }
  .process .noUi-target{
    box-shadow: none;
  }
  .pages{
    color: #F85252 !important;
  }
  .process .noUi-base .noUi-origin .noUi-handle-lower{
    box-shadow: none;
    background: #F85252;
    width: 12px !important;
    height: 12px !important;
    border-radius: 14px;
    top: -2px !important;
    left: -10px !important;
    border: none;
  }
  .ivu-page-item{

    background: #fff !important;
    background-size: 100% 100% !important;
    border-radius: 0 !important;
    border: 1px solid #F85252 !important;
    &.ivu-page-item-active{
      background: #F85252 !important;
      background-size: 100% 100% !important;
      border: 1px solid #F85252 !important;
      a{
        color: #fff !important;
      }
    }
    a{
      color: #F85252 !important;
    }
  }
  div.ivu-page-options-elevator input{
      background-color: #F85252;
      color:#fff;
      text-align: center;
  }
  .ivu-page-item-jump-next, .ivu-page-item-jump-prev, .ivu-page-next, .ivu-page-prev{
    background: #F85252 !important;
    background-size: 100% 100% !important;
    border-radius: 0 !important;
    border: 1px solid #fff !important;
    a{
      color: #fff !important;
    }
  }
  #app {
    height: auto;
    min-height: 100%;
    background-size: 100% 100%;
    // background: #fff;
  }

  ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: #999999;
  }

  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #999999;
  }

  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #999999;
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #999999;
  }

  html, body {
    height: 100%;
  }

  #app {
    position: relative;
    z-index: 9;
  }

  #app .qf-bg-color-img {
    position: fixed;
    left: 50%;
    top: 0;
    display: block;
    min-width: 100%;
    height: 100%;
    margin-left: -50%;
    z-index: -1;
  }

  // 淡入淡出
  .fade-enter-active, .fade-leave-active {
    transition: all .3s ease !important;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0 !important;
  }

  #caverling_alert {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.2s;
    user-select: none;
    z-index: 10000000;
    .alert_mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
    }
    .alert_content {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 300px;
      margin-top: -100px;
      margin-left: -150px;
      z-index: 2;
      border-radius: 15px;
      overflow: hidden;
      .jBox-title {
        height: 50px;
        line-height: 50px;
        padding-left: 20px;
        color: #fff;
        font-size: 18px;
        // background: #5FC1F0;
        background: linear-gradient(to bottom, #0590D0 0%, #004C8C 100%);
        .left {
          font-size: 18px;
        }
        .close-btn {
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          width: 42px;
          text-align: center;
          line-height: 42px;
          cursor: pointer;
          .icon {
            font-size: 18px;
          }
        }
      }
      .jBox-content {
        min-height: 120px;
        padding: 10px 16px;
        text-align: center;
        font-size: 16px;
        line-height: 120px;
      }
    }
  }

  .manager .modal-float .result {
    padding: 5px 0;
    display: none !important;
  }

  #EditSalaryPoint .modal-float .rangeset {
    /*display: none !important;*/
  }

  .pageUserNav-wrapper .manager-box table.form-control td a.colorLys1[data-command="salary"] {
    /*display: none !important;*/
  }
  body{
    .ivu-modal-content .ivu-modal-header{
      background: #F85252;
    }
    .ivu-modal-content .ivu-icon:before{
      color: #fff;
    }
    .modal_chaseNumber .ivu-modal .ivu-modal-body .nav{
      background: #feeded;
    }
    .modal_chaseNumber .ivu-modal .ivu-modal-body .nav .active{
      color: #F85252;
    }
    .ivu-modal-content .ivu-modal-footer button, .ivu-modal-content .ivu-modal-footer span{
      border: none;
      background: #F85252;
      color: #fff;
          border: 1px solid #fff;
    }
    .modal_orderDetail .ivu-modal-body .everyIssue_table ul .back span{
      background: #F85252;
    }
    .modal_orderDetail .ivu-modal-body .orderDetail_table {
        border-top: 1px solid #F85252;
        border-left: 1px solid #F85252;
    }
    .modal_orderDetail .ivu-modal-content{
      background: #fff;
    }
    .modal_orderDetail .ivu-modal-body .orderDetail_table .table_bottm .col1 span{
      color: #F85252;
    }
    .modal_orderDetail .ivu-modal-body .orderDetail_table .item .col1, .modal_orderDetail .ivu-modal-body .orderDetail_table .item .col2, .modal_orderDetail .ivu-modal-body .orderDetail_table .item .col3, .modal_orderDetail .ivu-modal-body .orderDetail_table .item .col4{
      color: #333;
      border-right: 1px solid #F85252;
      border-bottom: 1px solid #F85252;
    }
    .modal_againNote .ivu-modal-body .box .item_content .multipleBox{
      background: #fff;
      border: 1px solid #F85252;
      input,span{
        color: #F85252;

      }
      .reduce,.add{
        background: #feeded;
      }
    }
    .ivu-modal-content{
      box-shadow: none;
    }
    .modal_againNote .ivu-modal{
      height: 460px;
      background-size: 100% 100%;
    }
    .modal_againNote .ivu-modal-body .box .item_content .moneyMode{
      background: #fff;
      border: 1px solid #F85252;
      span{
        color: #F85252;
        &.active{
          background: #feeded;
        }
      }
    }
    .modal_orderDetail .ivu-modal-header{
      background: #F85252;
    }
    .modal_againNote .ivu-modal-footer .ivu-btn-text{
          background: transparent;
    }
    .modal_againNote .ivu-modal-footer .ivu-btn-primary{
      background: transparent;
    }
    .modal_againNote .ivu-modal-body .box .item_title, .modal_againNote .ivu-modal-body .box .item_content{
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?f9dad5bc